var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfileFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    fill: "none",
    viewBox: "0 0 21 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M17.85 0H3.15C2.572 0 2.1.469 2.1 1.042c0 .573.472 1.041 1.05 1.041h14.7c.577 0 1.05-.468 1.05-1.041S18.427 0 17.85 0ZM3.15 25h14.7a1.05 1.05 0 0 0 1.05-1.042c0-.573-.473-1.041-1.05-1.041H3.15c-.578 0-1.05.468-1.05 1.041S2.572 25 3.15 25ZM18.9 4.167H2.1C.945 4.167 0 5.104 0 6.25v12.5c0 1.146.945 2.083 2.1 2.083h16.8c1.155 0 2.1-.937 2.1-2.083V6.25a2.098 2.098 0 0 0-2.1-2.083ZM10.5 7.03a2.357 2.357 0 0 1 2.363 2.344 2.357 2.357 0 0 1-2.363 2.344 2.357 2.357 0 0 1-2.363-2.344A2.357 2.357 0 0 1 10.5 7.031Zm5.25 10.677H5.25v-1.562c0-1.74 3.496-2.604 5.25-2.604s5.25.864 5.25 2.604v1.562Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileFilled);
export default __webpack_public_path__ + "static/media/icon-profile-filled.b3c44c46.svg";
export { ForwardRef as ReactComponent };